import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Wheel } from 'react-custom-roulette'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGift, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useGetRouletteOptionsQuery } from '../../store/api/rouletteApi'
import { useTranslation } from 'react-i18next'
import { getGeneralInfo } from '../../utils/generalInfo'
import {
  WHEEL_PROPS,
  WheelHub,
} from '../checkout-page/components/RouletteWheel'

type Props = {
  setOpen: (isOpen: boolean) => void
}

const ViewRouletteWheel: React.FC<Props> = ({ setOpen }) => {
  const { data = [] } = useGetRouletteOptionsQuery()
  const { t } = useTranslation()
  const generalInfo = getGeneralInfo()

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false)
    const overflow = document.body.style.overflow

    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', onKey)

    return () => {
      document.body.style.overflow = overflow
      window.removeEventListener('keydown', onKey)
    }
  }, [setOpen])

  if (data.length === 0) {
    return null
  }

  return createPortal(
    <div className='roulette-overlay is-preview' onClick={() => setOpen(false)}>
      <div className='roulette-glow' />
      <button className='roulette-close' aria-label='Close'>
        <FontAwesomeIcon icon={faXmark} />
      </button>
      <div className='roulette-title'>
        <FontAwesomeIcon icon={faGift} /> {t('VIEW_ROULETTE_PRIZES')}
      </div>
      <div className='roulette-container'>
        <div className='wheel-wrapper is-idle'>
          <Wheel
            mustStartSpinning={false}
            prizeNumber={0}
            data={data}
            {...WHEEL_PROPS}
          />
          <WheelHub />
        </div>
      </div>
      {generalInfo.rouletteRules && (
        <div className='roulette-rules' onClick={(e) => e.stopPropagation()}>
          <div className='roulette-rules-title'>{t('DETAILS')}</div>
          <p>{generalInfo.rouletteRules}</p>
        </div>
      )}
    </div>,
    document.body,
  )
}

export default ViewRouletteWheel
